import { isTokenExpired, removeAuthentication } from '@connected/api-client/lib/authentication';
import { getLoginUrl, navigateToLogin } from '@connected/api-client/lib/login';
import { Button } from '@connected/ui/components/button';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { SyncStatus } from '@/components/sync-status';
import { AUTH_DEBUG } from '@/config/auth';

export const Route = createFileRoute('/(auth)')({
    beforeLoad: async ({ location }) => {
        const tokenStatus = isTokenExpired();

        if ((tokenStatus === 'EXPIRED' || tokenStatus === 'NO_TOKEN') && !AUTH_DEBUG) {
            // Check if we should proceed with redirect

            // Clean up expired token
            if (tokenStatus === 'EXPIRED') {
                removeAuthentication();
            }

            const loginUrl = getLoginUrl(location.href);
            throw redirect({ href: loginUrl });
        }
    },
    component: Layout,
});

function Layout() {
    if (isTokenExpired() === 'EXPIRED' && AUTH_DEBUG) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Button
                    onClick={() => navigateToLogin()}
                >
                    Niet ingelogd, inloggen (Nu auth)
                </Button>
            </div>
        );
    }
    return (
        <>
            <Outlet />
            <SyncStatus />
        </>
    );
}
